import { normalizePath } from '../../config/pageTitles';

// Вкладки keep-alive держат несколько страниц смонтированными сразу — каждая кладёт свой контекст по своему пути, дровер при отправке берёт запись активной вкладки.
const store = new Map();

export const setPageContext = (path, fields) => {
  const clean = {};
  Object.entries(fields || {}).forEach(([k, v]) => {
    if (v != null && v !== '') clean[k] = v;
  });
  store.set(normalizePath(path), clean);
};

export const getPageContext = (path) => store.get(normalizePath(path)) || null;

export const clearPageContext = (path) => store.delete(normalizePath(path));
